export const Gid: unique symbol = Symbol('ObjectGlobalIdProp');
export const Id: unique symbol = Symbol('ObjectIdProp');
export const Fields: unique symbol = Symbol('ObjectFieldsProp');
export const Locals: unique symbol = Symbol('ObjectLocalsProp');
export const Host: unique symbol = Symbol('ObjectHostProp');
export const Ticker: unique symbol = Symbol('ObjectTickerProp');
export const Type: unique symbol = Symbol('ObjectTypeProp');
